import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessBoardDeleteRequest } from '../types/JobChangeProcessBoard';
import parseBoardResponse from './parseBoardResponse';

export default function useDeleteJobChangeProcessBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ targetBoardId }: JobChangeProcessBoardDeleteRequest) => {
      const response = await fetch(`/agent/api/job_change_process_boards/${targetBoardId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      return parseBoardResponse(response, 'ボードの削除に失敗しました');
    },
  });
}
